import { render, staticRenderFns } from "./UnitTests.vue?vue&type=template&id=1342a667&scoped=true"
import script from "./UnitTests.vue?vue&type=script&lang=js"
export * from "./UnitTests.vue?vue&type=script&lang=js"
import style0 from "./UnitTests.vue?vue&type=style&index=0&id=1342a667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1342a667",
  null
  
)

export default component.exports